import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import 'borrower/borrower.scss';
import { z } from 'zod';

import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { ReceivableDetails } from 'packages/loanProduct/ui/receivablesDashboard/details/ReceivableDetails';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';

// Types
const RouteParamsStruct = z.object({
  finleyReceivableId: z.string({ message: 'Missing URL parameter' }),
});

// Exports
export const ReceivableDetailsRoute = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const params = useParams();
  const { finleyReceivableId } = RouteParamsStruct.parse(params);

  const { user } = useUserAuthOrThrow();

  let routeLevelError = false;

  return (
    <Box className="main">
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            routeLevelError = true;
            toast({
              ...errorToastConfig,
              id: 'errorLoadBorrowerReceivableDetails',
              title: 'Error loading borrower receivable details route',
            });
            navigate('/');
          }
        }}
      >
        <ReceivableDetails
          organizationId={user.organizationId}
          finleyReceivableId={finleyReceivableId}
          isLenderPage={false}
        />
      </Sentry.ErrorBoundary>
    </Box>
  );
};
